import Link from './Link';

export default function Footer() {
  return (
    <footer className="foot">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <Link className="brand" to="/" aria-label="User Evaluation, home">
              <svg className="wordmark" width="125" height="21" viewBox="0 0 790.65 132" aria-hidden="true" focusable="false">
                <use href="#ue-wordmark" />
              </svg>
            </Link>
            <p className="blurb">Ask real people. Let AI agents use your product. Keep all evidence in one place, and get study reports that cite each claim.</p>
          </div>
          <div>
            <h2>Product</h2>
            <ul>
              <li><Link to="/product">How it works</Link></li>
              <li><Link to="/interviews">Interviews</Link></li>
              <li><Link to="/swarm">Swarm</Link></li>
              <li><Link to="/analysis">Analysis &amp; study reports</Link></li>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <h2>Solutions</h2>
            <ul>
              <li><Link to="/use-cases">Use cases</Link></li>
              <li><Link to="/agencies">For agencies</Link></li>
              <li><Link to="/enterprise">Scale &amp; enterprise</Link></li>
              <li><Link to="/managed-study">Managed studies</Link></li>
              <li><Link to="/analyze">Free transcript analyzer</Link></li>
              <li><Link to="/integrations">Integrations</Link></li>
              <li><Link to="/developers">API</Link> &middot; <Link to="/mcp">MCP</Link></li>
            </ul>
          </div>
          <div>
            <h2>Company</h2>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact &amp; support</Link></li>
              <li><Link to="/ambassadors">Ambassadors</Link></li>
              <li><Link to="/get-paid">Get paid for interviews</Link></li>
            </ul>
          </div>
          <div>
            <h2>Legal</h2>
            <ul>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/cookie-policy">Cookie policy</Link></li>
              <li><Link to="/participant-consent">Participant consent</Link></li>
              <li><Link to="/participant-guarantee">Participant guarantee</Link></li>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>
        </div>
        <div className="foot-bot">
          <span>User Evaluation</span>
          <span>&copy; 2026 &middot; <Link to="/privacy">Privacy</Link> &middot; <Link to="/terms">Terms</Link></span>
        </div>
      </div>
    </footer>
  );
}
